// removed by extract-text-webpack-plugin
module.exports = {"icon":"FeV9WR3Y7MRyg2zQYrxDu"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/contracts/FilterIcon.scss
// module id = 1167
// module chunks = 0